import * as React from 'react';
export const warningSvg = React.forwardRef(function warningSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7 8.5a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0Zm-1-5a.867.867 0 0 0-.859.99l.288 2.015a.576.576 0 0 0 1.142 0l.288-2.015A.867.867 0 0 0 6 3.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.317 7.367A3 3 0 0 0 0 8.708V9a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-.292a3 3 0 0 0-.317-1.341L8.83 1.658A3 3 0 0 0 6.146 0h-.292a3 3 0 0 0-2.683 1.658L.317 7.367ZM9 10.6A1.6 1.6 0 0 0 10.6 9v-.292a1.6 1.6 0 0 0-.169-.715L7.577 2.284A1.6 1.6 0 0 0 6.146 1.4h-.292a1.6 1.6 0 0 0-1.431.884L1.569 7.993a1.6 1.6 0 0 0-.169.715V9A1.6 1.6 0 0 0 3 10.6h6Z',
    }),
  );
});
warningSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var warning = {
  category: 'icon',
  colorable: true,
  name: 'warning',
  svg: warningSvg,
};
